import { render, staticRenderFns } from "./SettingsToken.vue?vue&type=template&id=f8e6c26a&scoped=true"
import script from "./SettingsToken.vue?vue&type=script&lang=js"
export * from "./SettingsToken.vue?vue&type=script&lang=js"
import style0 from "./SettingsToken.vue?vue&type=style&index=0&id=f8e6c26a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e6c26a",
  null
  
)

export default component.exports